export default __webpack_public_path__ + "static/media/23_photo.e080e41b.jpeg";